import { makeStyles } from "tss-react/mui"
import { blueGrey, lightBlue } from "../../../../mp-core/themes/palette"
import { alpha, tableCellClasses } from "@mui/material"

type StylesClasses =
  | "tableWrapper"
  | "tableWrapperLoading"
  | "table"
  | "row"
  | "selectedRow"
  | "tableCell"
  | "headTableCell"
  | "bodyTableCell"
  | "clickable"
  | "sortIcon"
  | "activeSortIcon"
  | "emptyPlaceholder"

export const useStyles = makeStyles<void, StylesClasses>()(
  ({ spacing, palette }, _params, classes) => ({
    tableWrapper: {
      overflowY: "auto",
      maxHeight: "53vh",
      height: "100%",
      paddingRight: spacing(1),
      scrollbarWidth: "auto",
      scrollbarColor: "auto",

      "::-webkit-scrollbar": {
        width: "10px"
      }
    },
    tableWrapperLoading: {
      position: "relative",
      height: "100%"
    },
    table: {
      borderCollapse: "separate"
    },
    row: {
      height: "38px",

      "&:nth-of-type(even)": {
        backgroundColor: alpha(blueGrey[50], 0.5)
      },

      "&:hover": {
        backgroundColor: alpha(blueGrey[50], 1)
      },

      [`& .${tableCellClasses.root}`]: {
        borderTop: `1px solid transparent`,
        borderBottom: `1px solid transparent`,

        "&:first-of-type": {
          borderLeft: `1px solid transparent`
        },
        "&:last-of-type": {
          borderRight: `1px solid transparent`
        }
      },
      "&:focus, &:focus-within": {
        outline: `3px solid ${alpha(lightBlue[200], 0.2)}`,

        [`& .${tableCellClasses.root}`]: {
          borderColor: lightBlue[300]
        }
      }
    },
    selectedRow: {
      "&:nth-of-type(n)": {
        backgroundColor: lightBlue[50]
      }
    },
    tableCell: {
      padding: spacing(1, 3),
      cursor: "default"
    },
    tableHeadRow: {
      background: palette.common.white,
      position: "sticky",
      top: 0,
      height: "38px"
    },
    headTableCell: {
      borderBottom: `2px solid ${blueGrey[200]}`,
      userSelect: "none",
      background: `${alpha(blueGrey[50], 0.5)}`,

      [`&:hover .${classes.sortIcon}`]: {
        color: blueGrey[500]
      }
    },
    bodyTableCell: {
      borderBottom: "transparent",

      "& p": {
        wordBreak: "break-word"
      }
    },
    clickable: {
      cursor: "pointer"
    },
    sortIcon: {
      fontSize: "0.75rem",
      color: blueGrey[400],
      cursor: "pointer"
    },
    activeSortIcon: {
      color: blueGrey[800]
    },
    checkbox: {
      padding: spacing(0)
    },
    emptyPlaceholder: {
      color: blueGrey[600],
      textAlign: "center"
    }
  })
)
